import { AdvancedModeModule } from './../advanced-mode/advanced-mode.module';
import { PipesModule } from './../pipes/pipes.module';
import { NgModule } from '@angular/core';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { CommonModule } from '@angular/common';
import { FormlyCustomModule } from 'src/app/formly/formly.module';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ButtonModule, DropDownButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { UploadModule } from '@progress/kendo-angular-upload';
import { FormlyModule } from '@ngx-formly/core';
import { MemberAssessmentAddComponent } from './member-assessment-add/member-assessment-add.component';
import { MemberAssessmentComponent } from './member-assessment/member-assessment.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { CollapsibleModule } from '../collapsible/collapsible.module';
import { TaskAddModule } from '../task-add/task-add.module';
import { ReferralModule } from 'src/app/referral/referral.module';
import { PDFViewerModule } from '@progress/kendo-angular-pdfviewer';
import { ResizedModule } from '../resize-event/resized.module';

@NgModule({
    imports: [
        CommonModule,
        DialogsModule,
        PopupModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        LabelModule,
        DropDownsModule,
        LayoutModule,
        DateInputsModule,
        PipesModule,
        FormlyCustomModule,
        ButtonModule,
        DropDownButtonModule,
        ButtonsModule,
        UploadModule,
        FormlyModule,
        GridModule,
        DropDownsModule,
        AdvancedModeModule,
        CollapsibleModule,
        TaskAddModule,
        ReferralModule,
        PDFViewerModule,
        ResizedModule
    ],
    declarations: [
        MemberAssessmentAddComponent,
        MemberAssessmentComponent
    ],
    exports: [
        MemberAssessmentAddComponent,
        MemberAssessmentComponent
    ]
})
export class MemberAssessmentModule { }
